// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"7a64bb69","570":"cb4bd96f"}[chunkId] + ".chunk.js";
};